import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AttachmentType {
  img: Array<string>;
  pdf: Array<string>;
  excel: Array<string>;
}

const initialState: AttachmentType = {
  img: [],
  pdf: [],
  excel: [],
};

const attachmentSlice = createSlice({
  name: "attachment",
  initialState: initialState,
  reducers: {
    setAttachment: (state, action: PayloadAction<AttachmentType>) => {
      state.img = action.payload.img;
      state.pdf = action.payload.pdf;
      state.excel = action.payload.excel;
    },
    resetAttachments: () => initialState,
  },
});

export const { setAttachment, resetAttachments } = attachmentSlice.actions;

export default attachmentSlice.reducer;
